import React from 'react';
import { Search, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface EmptyStateProps {
  isGlobalDarkMode: boolean;
  searchQuery: string;
  clearSearch: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  isGlobalDarkMode,
  searchQuery,
  clearSearch
}) => {
  const navigate = useNavigate();

  return (
    <div className="text-center py-16">
      <div className="w-24 h-24 rounded-md flex items-center justify-center mx-auto mb-6 bg-muted">
        {searchQuery ? (
          <Search className="w-12 h-12 text-muted-foreground" />
        ) : (
          <Plus className="w-12 h-12 text-muted-foreground" />
        )}
      </div>
      <h3 className="text-xl font-semibold mb-2 text-foreground">
        {searchQuery ? 'No brands found' : 'No brands yet'}
      </h3>
      <p className="mb-6 text-muted-foreground">
        {searchQuery
          ? `No brands match your search for "${searchQuery}". Try a different search term.`
          : 'Create your first brand to get started'
        }
      </p>
      {searchQuery ? (
        <button
          onClick={clearSearch}
          className="px-6 py-3 bg-workspace-accent text-white rounded-md transition-colors hover:bg-workspace-accent-hover"
        >
          Clear Search
        </button>
      ) : (
        <button
          onClick={() => navigate('/onboarding')}
          className="px-6 py-3 bg-workspace-accent text-white rounded-md transition-colors hover:bg-workspace-accent-hover"
        >
          Create Your First Brand
        </button>
      )}
    </div>
  );
};
